import { getDndKitAccessibility } from 'core/utils/dragAndDropScreenReader';
import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import type { CanDrop, DndKitAccessibility } from 'core/utils/dragAndDropScreenReader';

/**
 * Prop `accessibility` de `DndContext`, traducida y estable entre renders. `canDrop` (las reglas del `onDragEnd` de la
 * vista) puede ser una función nueva en cada render: se lee al anunciar, no al crear el objeto.
 */
export default function useDndKitAccessibility(canDrop?: CanDrop): DndKitAccessibility {
  // dnd-kit vuelve a suscribir sus anuncios cada vez que recibe un objeto `accessibility` nuevo. La `t` de react-i18next
  // solo cambia con el idioma; la de `useTranslate` es nueva en cada render y no sirve como dependencia.
  const { t } = useTranslation();
  // Por ref: con los datos de la vista en las dependencias, cada arrastre o cambio de datos crearía un objeto nuevo.
  const canDropRef = useRef<CanDrop | undefined>(canDrop);
  canDropRef.current = canDrop;

  return useMemo(() => getDndKitAccessibility(t, (active, over) => canDropRef.current?.(active, over) ?? true), [t]);
}
